import { readItems } from "@directus/sdk";
import { useEffect, useRef, useState } from "react";
import { directus } from "../../Api/FetchDirectus";
import { useNavigate } from "react-router-dom";

const Menu = () => {
  const navigate = useNavigate();
  const [menuList, setMenuList] = useState<[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdownLeft, setShowDropdownLeft] = useState(false);
  const [showSecondMenuLeft, setShowSecondMenuLeft] = useState(false);
  const [showSecondDropdown, setShowSecondDropdown] = useState(false);
  const [load, setLoad] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const fetchHeader = async () => {
    try {
      return await directus.request(readItems(`menu`, { limit: -1 }));
    } catch (error: any) {
      sessionStorage.removeItem("token");
      navigate("/");
      return [];
    }
  };

  const fetchMenu = async () => {
    const list: { items: [] } | any = await fetchHeader();
    setMenuList(list.items);
  };

  useEffect(() => {
    setLoad(true);
    fetchMenu();
    setLoad(false);
  }, []);

  useEffect(() => {
    const rect = dropdownRef.current?.getBoundingClientRect();

    if (showDropdown && rect && rect.left < window.innerWidth / 2) {
      setShowDropdownLeft(false);
      setShowSecondMenuLeft(false);
    } else {
      setShowDropdownLeft(true);
      setShowSecondMenuLeft(true);
    }

    if (showDropdown && dropdownRef.current) {
      if (document.body.scrollWidth > window.innerWidth) {
      } else {
      }
    }
  }, [
    showDropdown,
    dropdownRef.current,
    document.body.scrollWidth,
    window.innerWidth,
  ]);

  return (
    <div className="menu">
      {!load &&
        menuList.map(
          (item: {
            title: string;
            children: {
              title: string;
              link: string;
              children: { title: string; link: string }[];
            }[];
            link: string;
          }) => (
            <>
              {" "}
              <a
                className="menuItem"
                href={
                  item.link
                    ? item.link.includes("http")
                      ? item.link
                      : item.link.includes("edu")
                      ? `https://edu.emir.gov.ru${item.link}`
                      : `https://emir.gov.ru${item.link}`
                    : ""
                }
                onMouseEnter={() => setShowDropdown(true)}
                onMouseLeave={() => setShowDropdown(false)}
              >
                {item.title}
                {item.children && (
                  <>
                    <div className="arrowBox">
                      <span />
                      <span />
                    </div>
                    <div
                      className={`menuDropdown ${showDropdown ? "show" : ""} ${
                        showDropdownLeft ? "leftMenu" : ""
                      }`}
                      ref={dropdownRef}
                    >
                      {item.children.map((dropdownItem) => (
                        <a
                          className="dropdownItem"
                          href={
                            dropdownItem.link
                              ? dropdownItem.link.includes("http")
                                ? dropdownItem.link
                                : dropdownItem.link.includes("edu")
                                ? `https://edu.emir.gov.ru${dropdownItem.link}`
                                : `https://emir.gov.ru${dropdownItem.link}`
                              : ""
                          }
                          onMouseEnter={() => setShowSecondDropdown(true)}
                          onMouseLeave={() => setShowSecondDropdown(false)}
                        >
                          {dropdownItem.title}
                          {dropdownItem.children && (
                            <>
                              <div className="dropdownArrowBox">
                                <span />
                                <span />
                              </div>
                              <div
                                className={`secondMenuDropdown ${
                                  showSecondDropdown ? "show" : ""
                                } ${showSecondMenuLeft ? "left" : ""}`}
                              >
                                {dropdownItem.children.map(
                                  (secondDropdownItem) => (
                                    <a
                                      key={secondDropdownItem.title}
                                      href={
                                        secondDropdownItem.link !== ""
                                          ? secondDropdownItem.link.includes(
                                              "http"
                                            )
                                            ? secondDropdownItem.link
                                            : secondDropdownItem.link.includes(
                                                "edu"
                                              )
                                            ? `https://edu.emir.gov.ru${secondDropdownItem.link}`
                                            : `https://emir.gov.ru${secondDropdownItem.link}`
                                          : ""
                                      }
                                      className="secondDropdownItem"
                                    >
                                      {secondDropdownItem.title}
                                    </a>
                                  )
                                )}
                              </div>
                            </>
                          )}
                        </a>
                      ))}
                    </div>
                  </>
                )}
              </a>
            </>
          )
        )}
    </div>
  );
};

export default Menu;
